import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStoreActions } from '~/store/store-context';
import { PracticeManagement } from '~/types/api.model';
import PMSetupPage from './PMSetupPage/PMSetupPage';
export const GetFinancialCentsSetupTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            FinancialCentsSetupTID: {
                Root: 'financial-cents-setup'
            }
        }
    });
export const FinancialCentsSetupPage = ()=>{
    const { FinancialCentsSetupTID } = useMemo(()=>GetFinancialCentsSetupTID(), []);
    const { api, fetchFinancialCentsItems } = useStoreActions();
    return /*#__PURE__*/ _jsx(PMSetupPage, {
        testId: FinancialCentsSetupTID.Root(),
        pmName: PracticeManagement.FinancialCents,
        doDisconnect: api.financialCents.disconnect,
        getItems: fetchFinancialCentsItems,
        linkServiceTemplate: api.financialCents.linkServiceTemplate,
        getServiceTemplateIntegratedIds: (template)=>template.integrations.financialCentsIntegratedIds()
    });
};
